import React, { Component, Fragment } from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import { employeeAvatarLink } from '../helper';
import { apiPost } from '../brainApi';

export default class CalendarNotesDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newNote: '',
    };
  }

  addPostedNote = (postedNote = null) => {
    const { event } = this.props;
    const { calendarNotes } = event;
    calendarNotes.push(postedNote);
    this.setState({ newNote: '' });
  };

  newNoteIsValid = () => {
    const { newNote } = this.state;
    return !!newNote;
  };

  postCalendarNote = () => {
    const { userInfo, event } = this.props;
    const { newNote } = this.state;
    const { employee_id } = userInfo;
    const date = moment(event.start).format('YYYY-MM-DD');

    const body = {
      service_vehicle_id: event.serviceVehicleId,
      date,
      employee_id,
      text: newNote,
    };

    apiPost('/calendar-note', body)
      .then((postedNote) => {
        this.addPostedNote(postedNote);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  formatNoteTime = (datetimeGMT) => {
    const datetimeLocal = moment
      .utc(datetimeGMT)
      .local()
      .format('hh:mm A MM/DD/YYYY');
    return `(${datetimeLocal})`;
  };

  render() {
    const { newNote } = this.state;
    const { open, event, userInfo, onClose } = this.props;
    const { calendarNotes, serviceVehicle, start, fullnessFilter } = event;
    const titleNotWord = fullnessFilter === 'dummyAlign' ? ' not' : '';

    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          Notes on {serviceVehicle.name},{titleNotWord} scheduled for{' '}
          {moment(start).format('MMM. D, YYYY')}
        </DialogTitle>

        <DialogContent>
          {calendarNotes.length < 1 ? (
            <DialogContentText>
              No notes yet. Be the first to add one!
            </DialogContentText>
          ) : (
            calendarNotes.map((note) => (
              <Fragment>
                <br />
                <span>
                  {employeeAvatarLink(note.employee.avatar_image_url)}
                  <span style={{ marginLeft: '10px' }}>
                    <strong>
                      {note.employee.first_name} {note.employee.last_name}
                    </strong>
                  </span>{' '}
                  <span style={{ fontSize: 11 }}>
                    {this.formatNoteTime(note.created_at)}
                  </span>
                </span>
                <DialogContentText
                  style={{ marginLeft: '50px', whiteSpace: 'pre-wrap' }}
                >
                  {note.text}
                </DialogContentText>
                <Divider />
              </Fragment>
            ))
          )}

          <br />
          <br />
          <br />

          <span>
            {employeeAvatarLink(userInfo.avatar_image_url)}
            <span style={{ marginLeft: '10px' }}>
              <strong>
                {userInfo.first_name} {userInfo.last_name}
              </strong>
            </span>
          </span>

          <TextField
            id="new_note"
            type="text"
            onChange={(e) => this.setState({ newNote: e.target.value })}
            value={newNote}
            label="Add a Note"
            fullWidth
            multiline
          />

          <br />
          <br />

          <Button
            onClick={this.postCalendarNote}
            color="primary"
            variant="contained"
            style={{ float: 'right' }}
            disabled={!this.newNoteIsValid()}
          >
            Post
          </Button>
        </DialogContent>
      </Dialog>
    );
  }
}
